import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ExtendedPropertyEditor.html?raw';
import lang from 'dojo/_base/lang';
import dojoQuery from 'dojo/query';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import PropertyValuesEditor from './PropertyValues/PropertyValuesEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

interface PropertyValueEntry {
    ID: string;
    description: string;
    is_active: boolean;
    order: number;
    coloration: any;
    value_double: number;
    value_text: string;
    isDeleted?: boolean;
    isNew?: boolean;
}
interface PropertyAssignmentEntry {
    ID: string;
    displayname: string;
    isDeleted?: boolean;
    isNew?: boolean;
}

class ExtendedPropertyEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private classNameContainer: HTMLElement;
    private classSelectionContainer: HTMLElement;
    private propertyAssignmentsContainer: HTMLElement;

    private extendedPropertyValuesTableContainer: HTMLElement;
    //private propertyAssignmentsTableContainer: HTMLElement;

    private propertyValuesEditor: MdsLax<InstanceType<typeof PropertyValuesEditor>> = null;

    private propertyValuesTable: MdsLax<InstanceType<typeof StaticTable>>;
    private propertyValuesEntries: Array<PropertyValueEntry> = [];
    private expanderExtendedPropertyValues: MdsLax<InstanceType<typeof ExpandableSection>>;

    //private propertyAssignmentsTable: StaticTable;
    //private propertyAssignmentsEntries: Array<PropertyAssignmentEntry> = [];
    //private expanderPropertyAssignments: ExpandableSection;

    private _updateTablesTimeoutHandler: any = null;

    private input_ClassSelection: MdsLax<InstanceType<typeof SearchSelect>>;
    private input_PropertyType: MdsLax<InstanceType<typeof SearchSelect>>;

    isValid(): boolean {

        if (this.isNew) {
            if (!this.input_ClassSelection.getValue()) return false;
        }
        if (!this.input_PropertyType.validateInput()) return false;
        return true;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.UiModder.domClass.remove(this.classNameContainer, "w3-hide");
        this.UiModder.domClass.add(this.classSelectionContainer, "w3-hide");

        this.showEditor(true);
        this.adjustEditorForPropertyType();

        this.propertyValuesEntries = lang.clone(this.getAttributeValue("extended_property_values"));
        //this.propertyAssignmentsEntries = lang.clone(this.getAttributeValue("property_assignments"));

        if (this._updateTablesTimeoutHandler != null) {
            clearTimeout(this._updateTablesTimeoutHandler);

            //this.updatePropertyAssignmentsTable();
            this.updatePropertyValuesTable();
        }
    }

    private adjustEditorForPropertyType() {

        let type = this.getAttributeValue("property_type");

        let nodeList = dojoQuery("[data-property-type]", this.domNode);

        nodeList.forEach((node) => {
            let propType: string = this.UiModder.domAttr.getNodeProp(node, "data-property-type");
            let typeArr: Array<string> = propType.split(" ");

            this.hideNode(node, typeArr.indexOf(type) === -1);
        });
    }

    private showEditor(show: boolean) {

        this.hideNode(this.editFormLeftSection, !show);
        this.hideNode(this.editFormRightSection, !show);
        this.hideNode(this.propertyAssignmentsContainer, !show);
    }

    private _onChange_ClassSelection() {

        if (!this.isNew) return;

        this.showEditor(this.input_ClassSelection.getValue());
        this.setAttributeValue("selectedClass", this.input_ClassSelection.getValue(), true);
    }

    private _onChange_PropertyType(key: string, newValue: { Value: string } | string, oldValue: string) {

        if (newValue && typeof newValue != "string") {
            this.setAttributeValue(key, newValue.Value);
        }
        this.getAttributeValue("property_type");
        this.adjustEditorForPropertyType();
    }

    private _onChange_PropertyValue(data: { ID: string, changedData: PropertyValueEntry }) {

        this.editPropertyValue(data.ID, data.changedData)
    }

    private _onPropertyValue_RowClick(row: StaticTable.StaticTableRow<PropertyValueEntry>, rowGroup: StaticTable.StaticTableRowGroup<PropertyValueEntry>) {
        let entry = rowGroup.entity;

        this.openPropertyValueEditor(entry);
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ExtendedProperty;
    }

    private editPropertyValue(entryId: string, changedData: PropertyValueEntry) {

        let editedEntry = this.propertyValuesEntries.filter(x => x.ID === entryId)[0];

        for (let p in changedData) {

            editedEntry[p] = changedData[p];
        }

        this.setAttributeValue("extended_property_values", lang.clone(this.propertyValuesEntries));
        this.updatePropertyValuesTable();
    }

    private openPropertyValueEditor(entry: PropertyValueEntry) {

        this.propertyValuesEditor = new PropertyValuesEditor();
        let dlg = new GenericDialog();

        this.propertyValuesEditor.setData(entry);
        this.propertyValuesEditor.on("PropertyValues_ChangedData", lang.hitch(this, this._onChange_PropertyValue))

        dlg.show(this.propertyValuesEditor,
            entry.description ? entry.description : `${this.translate("General_New")} - ${this.translate("General_Label_ExtendedPropertyValue")}`,
            null, null,
            "ok",
            (result) => {
                if (result === 1) {
                    if (this.propertyValuesEditor.isValid()) dlg.close();
                    else this.propertyValuesEditor.showToast(this.translate("MainCatalogsEditor_Error_InvalidData"), "fas fa-exclamation-triangle");
                } else {
                    if (entry.isNew) this.removePropertyValueEntry(this.propertyValuesTable.getRowGroupByKeyValue(entry.ID, "ID"));
                    dlg.close()
                }
            },
            {
                keepOpen: true,
                closeOnEnter: false
            }
        );
    }

    private _onClick_NewPropValue() {

        this.addNewPropertyValueEntry();
    }

    private addNewPropertyValueEntry() {

        let fakeEntry: Partial<PropertyValueEntry> = {
            ID: (Math.random() * 100000).toString(),
            description: "",
            order: this.propertyValuesTable.getRowCount() + 1,
            is_active: true,
            isNew: true
        }

        this.propertyValuesEntries.push(fakeEntry as PropertyValueEntry);

        this.setAttributeValue("extended_property_values", lang.clone(this.propertyValuesEntries));

        this.updatePropertyValuesTable();

        this.openPropertyValueEditor(fakeEntry as PropertyValueEntry);
    }

    private removePropertyValueEntry(rowGr: StaticTable.StaticTableRowGroup<PropertyValueEntry>) {

        let entry = rowGr.entity;
        let deletedEntry = this.propertyValuesEntries.filter(x => x.ID === entry.ID)[0];

        if (entry.isNew) {

            this.propertyValuesEntries.splice(this.propertyValuesEntries.indexOf(deletedEntry), 1);
        } else {

            deletedEntry.isDeleted = true;
        }

        this.setAttributeValue("extended_property_values", lang.clone(this.propertyValuesEntries));
        this.updatePropertyValuesTable();
    }

    private updatePropertyValuesTable() {

        let propertyValuesEntries: Array<PropertyValueEntry> = lang.clone(this.getAttributeValue("extended_property_values"));

        propertyValuesEntries?.length > 0 ? this.expanderExtendedPropertyValues.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderExtendedPropertyValues.setMarking(ExpandableSectionMarkings.default);

        this.propertyValuesTable.setData(propertyValuesEntries);

        propertyValuesEntries?.forEach(v => {
            if (v.isDeleted === true) {
                this.disableNode(this.propertyValuesTable.getRowGroupByKeyValue(v.ID, "ID").rows[0].node);
            }
        })
    }

    //private updatePropertyAssignmentsTable() {

    //    let propertyAssignmentsEntries: Array<PropertyAssignmentEntry> = lang.clone(this.getAttributeValue("property_assignments"));

    //    propertyAssignmentsEntries?.length > 0 ? this.expanderPropertyAssignments.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderPropertyAssignments.setMarking(ExpandableSectionMarkings.default);

    //    this.propertyAssignmentsTable.setData(propertyAssignmentsEntries);

    //    //propertyAssignmentsEntries?.forEach(a => {
    //    //    if (a.isDeleted === true) {
    //    //        this.disableNode(this.propertyAssignmentsTable.getRowGroupByKeyValue(a.ID, "ID").rows[0].node);
    //    //    }
    //    //})
    //}

    private _onRowSorting(rowGroup: StaticTable.StaticTableRowGroup<PropertyValueEntry>) {

        let count = this.propertyValuesTable.getRowCount();

        for (var i = 0; i < count; i++) {
            let tableEntry = this.propertyValuesTable.getRowGroup(i).entity as PropertyValueEntry;

            let editedEntry = this.propertyValuesEntries.filter(x => x.ID === tableEntry.ID)[0];

            editedEntry.order = tableEntry.order;
        }
        this.setAttributeValue("extended_property_values", this.propertyValuesEntries)
    }

    private _setUpTables(response: { layouts: Array<any> }) {

        if (this.propertyValuesTable != null) this.propertyValuesTable.destroy();
        //if (this.propertyAssignmentsTable != null) this.propertyAssignmentsTable.destroy();

        this.propertyValuesTable = new StaticTable();
        this.propertyValuesTable.setupRowSorting("order");

        this.propertyValuesTable.placeAt(this.extendedPropertyValuesTableContainer);

        let map = response.layouts.map((l) => { return l.name; });

        this.propertyValuesTable.setLayout(response.layouts[map.indexOf("property_values")]);
        this.propertyValuesTable.addDefaultRowActionButton("rowsorting", lang.hitch(this, this._onRowSorting));
        this.propertyValuesTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removePropertyValueEntry));

        this.propertyValuesTable.setRowClick(lang.hitch(this, this._onPropertyValue_RowClick))

        this.propertyValuesTable.setCyAttribute("ExtendedPropertyEditorPropertyValuesTable");
        
        //this.propertyAssignmentsTable = new StaticTable();
        //this.propertyAssignmentsTable.placeAt(this.propertyAssignmentsTableContainer);

        //this.propertyAssignmentsTable.setLayout(response.layouts[map.indexOf("property_assignments")]);
        //this.assignmentsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeEntry, MCT.TodoDescription_SelectedEntriesListNames.associateGroups, "groupID"));

        //this.associateGroupsTable.setRowClick(lang.hitch(this, this._onRowClick))
              
        this._updateTablesTimeoutHandler = setTimeout(() => {
            //this.updatePropertyAssignmentsTable();
            this.updatePropertyValuesTable();
        }, 500);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addOnchanged("property_type", lang.hitch(this, this._onChange_PropertyType))

        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetExtendedPropertyListsTablesLayouts",
            null,
            lang.hitch(this, this._setUpTables),
            (err) => { this.showToast(err.Message) }
        )
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(ExtendedPropertyEditor);